import { Link, useNavigate } from 'react-router-dom';
import { useCartStore } from '../../store/cartStore';
import styles from './CartDrawer.module.css';

export default function CartDrawer() {
  const { items, isOpen, closeCart, removeItem, total } = useCartStore();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const orderTotal = total();

  return (
    <>
      <div className={styles.overlay} onClick={closeCart} />
      <aside className={styles.drawer}>
        <div className={styles.header}>
          <div className={styles.title}>
            Cart
            {items.length > 0 && (
              <span className={styles.count}>{items.length} item{items.length > 1 ? 's' : ''}</span>
            )}
          </div>
          <button className={styles.closeBtn} onClick={closeCart} aria-label="Close cart">✕</button>
        </div>

        {items.length === 0 ? (
          <div className={styles.empty}>
            <div className={styles.emptyIcon}>◈</div>
            <div className={styles.emptyTitle}>Your cart is empty</div>
            <p className={styles.emptyText}>Add AI agents to get started</p>
            <Link to="/explore" className={styles.emptyLink} onClick={closeCart}>
              Browse marketplace →
            </Link>
          </div>
        ) : (
          <>
            <div className={styles.items}>
              {items.map(({ product }) => (
                <div key={product.id} className={styles.item}>
                  <div className={styles.itemThumb}>
                    {product.preview_image_urls[0]
                      ? <img src={product.preview_image_urls[0]} alt={product.title} />
                      : <span>◈</span>
                    }
                  </div>
                  <div className={styles.itemInfo}>
                    <div className={styles.itemTitle}>{product.title}</div>
                    <div className={styles.itemSeller}>@{product.seller?.username}</div>
                  </div>
                  <div className={styles.itemRight}>
                    {product.is_free
                      ? <span className={styles.itemPriceFree}>FREE</span>
                      : <span className={styles.itemPrice}>${product.price.toFixed(2)}</span>
                    }
                    <button
                      className={styles.removeBtn}
                      onClick={() => removeItem(product.id)}
                      aria-label="Remove item"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.footer}>
              <div className={styles.subtotalRow}>
                <span>Order total</span>
                <span className={styles.subtotalAmount}>${orderTotal.toFixed(2)}</span>
              </div>
              <button className={styles.checkoutBtn} onClick={() => { closeCart(); navigate('/checkout'); }}>
                Checkout — ${orderTotal.toFixed(2)}
              </button>
              <div className={styles.secureNote}>
                🔒 Secured by Stripe · 256-bit encryption
              </div>
            </div>
          </>
        )}
      </aside>
    </>
  );
}
